<template>
  <div @click="onClick">
       
       <div class="inline field">
        <label>RFQ Loc ID: </label>
        <span>{{rowData.RFQlocID}}</span>
      </div>
          <div class="inline field">
        <label>RFQ Vendor Corp ID: </label>
        <span>{{rowData.RFQvendorCorpID}}</span>
      </div>
     
      <div class="inline field">
        <label>Corp ID: </label>
        <span>{{rowData.corpId}}</span>
      </div>
      <div class="inline field">
        <label>Community ID : </label>
        <span>{{rowData.communityId}}</span>
      </div>
      <div class="inline field">
        <label>Location Address : </label>
        <span>{{rowData.locationAddress}}</span>
      </div>
   
      
     
</div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    onClick (event) {
            console.log('MemberVendorDetails: on-click', event.target)
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/components/ipo/MemberVendorDetails.vue